import { render, staticRenderFns } from "./internalList.vue?vue&type=template&id=6f40a1cc&scoped=true&"
import script from "./internalList.vue?vue&type=script&lang=js&"
export * from "./internalList.vue?vue&type=script&lang=js&"
import style0 from "./internalList.vue?vue&type=style&index=0&id=6f40a1cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f40a1cc",
  null
  
)

export default component.exports